import { AuthenticationResultType, CognitoIdentityProviderClient, InitiateAuthCommand, InitiateAuthCommandOutput, RespondToAuthChallengeCommand, RespondToAuthChallengeCommandOutput } from "@aws-sdk/client-cognito-identity-provider";

class UserPoolManager {
    cognitoClient?: CognitoIdentityProviderClient;
    spiffRegion?: string;
    userPoolClientId?: string;

    private challengeSession?: string;

    init(spiffRegion: string, userPoolRegion: string, userPoolClientId: string) {
        this.cognitoClient = new CognitoIdentityProviderClient({ region: userPoolRegion });
        this.spiffRegion = spiffRegion;
        this.userPoolClientId = userPoolClientId;
    }

    async generateCode(emailAddress: string): Promise<void> {
        const response = await this.cognitoClient?.send(
            new InitiateAuthCommand({
                AuthFlow: "CUSTOM_AUTH",
                ClientId: this.userPoolClientId,
                AuthParameters: {
                    USERNAME: emailAddress,
                },
            }),
        );
        if (response?.ChallengeName === "CUSTOM_CHALLENGE") {
            this.challengeSession = response.Session;
        }
    }

    async verifyCode(emailAddress: string, code: string, partnerId: string): Promise<RespondToAuthChallengeCommandOutput | undefined> {
        return await this.cognitoClient?.send(
            new RespondToAuthChallengeCommand({
                ClientId: this.userPoolClientId,
                ChallengeName: "CUSTOM_CHALLENGE",
                Session: this.challengeSession,
                ChallengeResponses: {
                    USERNAME: emailAddress,
                    ANSWER: code,
                },
                ClientMetadata: {
                    partnerId,
                    environment: (this.spiffRegion || "").toLowerCase(),
                },
            }),
        );
    }

    async refreshTokens(): Promise<InitiateAuthCommandOutput | undefined> {
        const existingTokensString = localStorage.getItem("cognito-tokens");
        if (!existingTokensString) {
            throw new Error("Failed to find existing tokens.");
        }
        const existingTokens: AuthenticationResultType = JSON.parse(existingTokensString);
        return await this.cognitoClient?.send(
            new InitiateAuthCommand({
                AuthFlow: "REFRESH_TOKEN_AUTH",
                ClientId: this.userPoolClientId,
                AuthParameters: {
                    "REFRESH_TOKEN": existingTokens.RefreshToken || "",
                },
            }),
        );
    }
}

const userPoolManager = new UserPoolManager();
export { userPoolManager };